import React, {  useEffect, useState } from 'react';
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import ProjectTable from './ProjectTable';
// import { useOktaAuth } from '@okta/okta-react';
import Loader from '../../component/Loader/Loader';
import Breadcrumb from '../../component/Breadcrumb';
import { Box, Grid, Typography } from '@mui/material';
import { fetchProjectsList , getConfigFileContentForEditing, deleteConfigFile, closeConfigFile } from '../../api/mappingApi';
import { useMsal } from "@azure/msal-react";

const ProjectsList = () => {
    const { instance }  = useMsal();
    const accounts      = instance.getAllAccounts();
    // const { authState }                   = useOktaAuth();
    const [page, setPage]                 = useState(0);
    const [showLoader, setShowLoader]     = useState(false);
    const [rowsPerPage, setRowsPerPage]   = useState(20);
    const [tableData, setTableDataData]   = useState([]);

    const handleChangePage = (event, pageVal) => {
        setPage(pageVal);
    }
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value);
        setPage(0);
    }


    const handleDeleteProject = async(rowId) => {
        setShowLoader(true);
        await deleteConfigFile(rowId);
        setShowLoader(false);
        swal({
            title: "Success",
            text: 'Project deleted successfully.',
            icon: "success",
        })
        fetchData();
    }

    const handleEditProject = async (rowId) => {
        const keys = Object.keys(localStorage);
        const localStorageItem = keys.some((k) => k === 'Connections' || k === 'Parameters' || k === 'Events' || k === 'ECURequestPGN' || k === 'ECUReceiveMessages' || k === 'ECUConstantTxMessages' || k === 'HomePage' || k === 'ECUIDDefinitions' || k === 'ECUTransmitMessages' || k === 'Modbus' ? true : false);
        if(localStorageItem){
            swal({title: "Error",text: 'Please close current editing project to edit others..',icon: "error"})
            return;
        }
        setShowLoader(true);
        const fileData  = await getConfigFileContentForEditing(rowId);
        setShowLoader(false);
        setFileDataInStorage(fileData);
        fetchData();
    }


    const setFileDataInStorage = (data) => {
        if(data){
            for(let key in data){
                if(key === 'Connections' || key === 'Parameters' || key === 'Events' || key === 'ECURequestPGN' || key === 'ECUReceiveMessages' || key === 'ECUConstantTxMessages' || key === 'HomePage' || key === 'ECUIDDefinitions' || key === 'ECUTransmitMessages' || key === 'Modbus'){
                  localStorage.setItem(key,JSON.stringify(data[key]));
                }
            }
            localStorage.setItem('ProjectEditing',true);
        }
    }

    const fetchData = async () => {
        setShowLoader(true);
        // const addedBy   = authState?.accessToken?.claims?.sub;
        const addedBy   = accounts[0]?.username;
        const data      = await fetchProjectsList(page,rowsPerPage,addedBy);
        setShowLoader(false);
        setTableDataData(data);
    }

    useEffect(() => {
        fetchData();
      },[page,rowsPerPage])


    const handleCloseProject = async(rowId) => {
        swal({
            title: "Are you sure?",
            text: "Before closing project please save file so that changes can be saved on file!",
            icon: "warning",
            buttons: ["Cancel", "Close"],
          })
          .then(async willCancel => {
            if (willCancel) {
                setShowLoader(true);
                let result = await closeConfigFile(rowId);
                setShowLoader(false);
                const keys = Object.keys(localStorage);
                for(let key in keys){
                    if(keys[key] === 'Connections' || keys[key] === 'Parameters' || keys[key] === 'Events' || keys[key] === 'ECURequestPGN' || keys[key] === 'ECUReceiveMessages' || keys[key] === 'ECUConstantTxMessages' || keys[key] === 'HomePage' || keys[key] === 'ECUIDDefinitions' || keys[key] === 'ECUTransmitMessages' || keys[key] === 'Modbus'){
                      localStorage.removeItem(keys[key]);
                    }
                }
                localStorage.removeItem('ProjectEditing');
                fetchData();
                if(result){
                    swal({
                        title: "Success",
                        text: result.message,
                        icon: "success",
                    })
                }
            }
        });
        
        // keys.filter((k) => k === 'Connections' || k === 'Parameters' || k === 'Events' || k === 'ECURequestPGN' || k === 'ECUReceiveMessages' || k === 'ECUConstantTxMessages' || k === 'HomePage' || k === 'ECUIDDefinitions' || k === 'ECUTransmitMessages' || k === 'Modbus').map((key) => data[key] = localStorage?.getItem(key) ? JSON.parse(localStorage?.getItem(key)) : '');
        // let jsonString = JSON.stringify(data,null,2);
        // const formData = new FormData();
        // formData.append('uploadFile',new Blob([jsonString],{type:'plain/text'}),'data.txt')
        // formData.append('rowId',rowId);
        // setShowLoader(true);
        // let result = await saveContentCloseConfigFile(formData);
        // setShowLoader(false);
        // for(let key in data){
        //     if(key === 'Connections' || key === 'Parameters' || key === 'Events' || key === 'ECURequestPGN' || key === 'ECUReceiveMessages' || key === 'ECUConstantTxMessages' || key === 'HomePage' || key === 'ECUIDDefinitions' || key === 'ECUTransmitMessages' || key === 'Modbus'){
        //       localStorage.removeItem(key);
        //     }
        // }
        // fetchData();
        // if(result){
        //     swal({
        //         title: "Success",
        //         text: result.message,
        //         icon: "success",
        //     })
        // }
    }  

    return (
        <>
            {showLoader && 
            <Loader />
            }
            <Breadcrumb  title="Projects">
                <Typography component={Link} to="/" variant="subtitle2" color="primary"  className="link-breadcrumb">
                    Dashboard
                </Typography>
                <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
                    Projects List
                </Typography>
            </Breadcrumb>
            <Box  component="section">
                <Grid className="contentBox">
                    <ProjectTable 
                        page                    = {page} 
                        rowsPerPage             = {rowsPerPage}
                        tableData               = {tableData}
                        handleChangePage        = {handleChangePage}
                        handleChangeRowsPerPage = {handleChangeRowsPerPage}
                        handleEditProject       = {handleEditProject}
                        handleDeleteProject     = {handleDeleteProject}
                        handleCloseProject      = {handleCloseProject}
                    />
                </Grid>
            </Box>
        </>
    )
}

export default ProjectsList